import { Route, Routes, useNavigate } from "react-router-dom"
import { Albums, Home, Admin, Blogs, Contact } from "../pages"

import { auth } from "../firebase"


const AllRoutes = () => {
  const Navigate = useNavigate();
  const isAuthenticated = auth.currentUser;
  return (
    <div>
        <Routes>
            <Route path="/" element={<Home />}></Route>
            <Route path="/albums" element={<Albums />}></Route>
            <Route path="/admin-dashboard" element={isAuthenticated ? <Admin /> : <Navigate to="/" />}></Route>
            <Route path="/blog" element={<Blogs />}></Route>
            <Route path="/contact" element={<Contact />}></Route>
        </Routes>
    </div>
  )
}

export default AllRoutes